import React from 'react';
import type { BenzingaLogoProps } from '../BenzingaLogo';

const BenzingaLogo = React.lazy(() => import('../BenzingaLogo'));
const BenzingaJapanLogo = React.lazy(() => import('../BenzingaJapanLogo'));
const BenzingaKoreaLogo = React.lazy(() => import('../BenzingaKoreaLogo'));
const BenzingaCryptoLogo = React.lazy(() => import('../BenzingaCryptoLogo'));
const BenzingaEsLogo = React.lazy(() => import('../BenzingaEsLogo'));
const BenzingaItLogo = React.lazy(() => import('../BenzingaItLogo'));
const BenzingaFrLogo = React.lazy(() => import('../BenzingaFrLogo'));

// 'india' is retained until the india identity/DOMAINS config is torn down (fusion#15933 follow-up);
// the BenzingaIndiaLogo component is gone, so 'india' now falls through to the default logo.
export type MainLogoVariant = 'india' | 'japan' | 'korea' | 'default' | 'crypto' | 'spain' | 'italy' | 'france';

interface Props extends BenzingaLogoProps {
  logoVariant?: MainLogoVariant;
}

export const MainLogo: React.FC<Props> = ({ logoVariant, ...props }) => {
  const logo = React.useMemo(() => {
    let logo: any | null = null;
    switch (logoVariant) {
      case 'japan': {
        logo = <BenzingaJapanLogo />;
        break;
      }
      case 'korea': {
        logo = <BenzingaKoreaLogo />;
        break;
      }
      case 'default': {
        logo = <BenzingaLogo {...props} />;
        break;
      }
      case 'crypto': {
        logo = <BenzingaCryptoLogo {...props} />;
        break;
      }
      case 'spain': {
        logo = <BenzingaEsLogo variant={props.variant} />;
        break;
      }
      case 'italy': {
        logo = <BenzingaItLogo variant={props.variant} />;
        break;
      }
      case 'france': {
        logo = <BenzingaFrLogo variant={props.variant} />;
        break;
      }
      default: {
        logo = <BenzingaLogo {...props} />;
        break;
      }
    }

    return logo;
  }, [logoVariant, props]);

  return <>{logo}</>;
};
